import Mass from '@FreeRider/Physics/Mass';
import UniqueID from '@Utils/Misc/UniqueID'

class Powerup
{
    public type: string;
    public id: string;
    public x: number;
    public y: number;

    /**
     * Constructor
     * @param x
     * @param y
     */
    constructor(x: number, y: number)
    {
        this.x = x;
        this.y = y;
        this.id = UniqueID()
    }

    /**
     * Collides with mass
     * @param mass
     */
    public collide(mass:Mass)
    {

    }
}

export default Powerup;